
  import Vue from "vue";
  import Component from "vue-class-component";
  import {NotificationModel, NotificationsClient, NotificationState, ResultError} from "@/api-client";
  import toasts from "@/components/Toasts";
  import bus from "@/EventBus";
  import userInfo from "@/features/shared/components/UserInfo";
  import {authService} from "@/AuthService";

  @Component
  export default class NavNotification extends Vue {
      notifications: NotificationModel[] = [];
      
      notificationsTimer: number | undefined;
      totalNotificationCount = 0;
      
      userInfo = userInfo;
      
      async created() {
          bus.subscribe("notification-update-triggered", () => this.getNotifications(), this);
          await this.getNotifications();
          this.notificationsTimer = setInterval(() => bus.publish("notification-update-triggered"), 1000 * 60);
          this.$watch(() => this.userInfo, async () => { // Update notifications after profile change.
              if (authService.hasProfileSelected())
                  bus.publish("notification-update-triggered");
          }, {deep: true})
      }
      
      async markRead(notification: NotificationModel) {
          await new NotificationsClient().markRead([notification.id])
              .then(() => bus.publish("notification-update-triggered"),
                  (error: ResultError) => error.messagesFlattened.forEach(x => toasts.failure(x)));
      }
      
      async getNotifications() {
          const queryResult = await new NotificationsClient().get(1,10,[NotificationState.Unread]);
          this.notifications = queryResult.pageResult;
          this.totalNotificationCount = queryResult.totalCount;
      }
  }
